import { useState } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.js';

/** A Quality credential choice remains focusable while its accepted request finishes. */
export function ConnectionChoiceSelect({
  id,
  value,
  options,
  blocked,
  onValueChange,
}: {
  id: string;
  value: string;
  options: readonly { value: string; label: string }[];
  blocked: () => boolean;
  onValueChange: (value: string) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Select
      value={value}
      open={open}
      onOpenChange={(next) => {
        if (next && blocked()) return;
        setOpen(next);
      }}
      onValueChange={(next) => {
        if (!blocked()) onValueChange(next);
      }}
    >
      <SelectTrigger id={id} className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
